'use client';

import { create } from 'zustand';

export interface AdsSlice {
  gptLoaded: boolean;
  setGptLoaded: (gptLoaded: boolean) => void;
  pbjsLoaded: boolean | null;
  setPbjsLoaded: (pbjsLoaded: boolean) => void;
}

export const useAdsStore = create<AdsSlice>((set) => ({
  gptLoaded: false,
  setGptLoaded: (gptLoaded) => set({ gptLoaded }),
  pbjsLoaded: null,
  setPbjsLoaded: (pbjsLoaded) => set({ pbjsLoaded }),
}));
